<template>
  <div @click="onclick()" class="item button">
    <div class="l">
      <img class="item-icon" :src="src" />
      <span class="item-title">{{ title }}</span>
      <span class="item-title copy" v-if="isCopy" @click="copySuccess(title)">{{
        $t("Copy")
      }}</span>
    </div>
    <!-- <span class="iconfont arrow">&#xe650;</span> -->
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  props: {
    isCopy: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    src: {
      type: String,
    },
  },
  methods: {
    onclick() {
      this.$emit("onclick");
    },
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t("succ"));
          // console.log(e);
        },
        (e) => {
          Toast(this.$t("err"));
          // console.log(e);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* 父容器样式 */

/* 每个 .item 元素的宽度 */
.item {
  width: 32%; /* 设置宽度为 1/3，减去间距，保证一行三个 */
  // padding: 1rem 0 0 0;
  text-align: center;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f6f6f6;
}

/* 其他样式保持不变 */
.item:last-child {
  border-bottom: none;
}

.l {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.item-icon {
  display: block;
  width: 2rem;
}

.item-title {
  margin-top: 10px;
  display: block;
  font-size: 11px;
  color: rgba(51, 51, 51, 1);
  height: 1rem;
  line-height: 1rem;
  white-space: nowrap;
}

.copy {
  color: $primaryColor;
  font-weight: 600;
  margin: 0 0.5rem;
  font-size: 0.5rem;
}

.arrow {
  font-size: 0.6rem;
  font-weight: 800;
  color: #b4b6bf;
}
</style>
